import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <section className="border-t border-slate-200 pt-7 first:border-t-0 first:pt-0">
    <h2 className="font-[Playfair_Display] text-2xl font-semibold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-7 text-slate-700">{children}</div>
  </section>
);

export const AccountDeletionPage = () => {
  useEffect(() => {
    document.title = "Konto und Daten löschen | Business Studio Suite";
  }, []);

  return (
    <main className="min-h-screen bg-[#f7f4ee] px-4 py-8 text-slate-900" data-testid="account-deletion-page">
      <div className="mx-auto max-w-4xl">
        <header className="mb-6 flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#9c742e]">Business Studio Suite</p>
            <h1 className="mt-1 font-[Playfair_Display] text-3xl font-semibold">Konto und Daten löschen</h1>
            <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600">
              Diese Seite erklärt den selbstbestimmten Löschweg in der Business Studio Suite. Die Löschung wird von der angemeldeten Person ausgelöst und benötigt keine zusätzliche Freigabe durch eine Administration.
            </p>
          </div>
          <Link
            to="/app"
            className="rounded-full border border-slate-300 bg-white px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
            data-testid="account-deletion-start-app"
          >
            Zur Anmeldung
          </Link>
        </header>

        <article className="space-y-7 rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <Section title="So startest du die Löschung">
            <ol className="list-decimal space-y-2 pl-5">
              <li>Melde dich in der Business Studio Suite an.</li>
              <li>Öffne in der mobilen App <strong>Mehr → Konto und Daten löschen</strong>.</li>
              <li>Bestätige mit deinem aktuellen Passwort und dem Wort <strong>LÖSCHEN</strong>.</li>
              <li>Bestätige den finalen Hinweis. Es folgt keine zusätzliche Freigabe durch eine Administration.</li>
            </ol>
          </Section>

          <Section title="Umfang der Löschung">
            <p>
              Ein Teammitglied oder ein Admin mit weiteren Admins löscht ausschließlich das eigene Benutzerkonto. Der Arbeitsbereich und die Daten der übrigen Mitglieder bleiben erhalten.
            </p>
            <p>
              Löscht der letzte Admin eines Arbeitsbereichs das eigene Konto, werden das Konto und die organisationsbezogenen Daten dieses Arbeitsbereichs gelöscht. Ein minimaler, nicht rückführbarer Löschvermerk mit gehashtem E-Mail-Bezug bleibt für den technischen Nachweis bestehen.
            </p>
          </Section>

          <Section title="Wichtige Hinweise">
            <p>
              Die Löschung kann nicht rückgängig gemacht werden. Prüfe vor dem Start insbesondere gesetzliche Aufbewahrungspflichten für Geschäftsunterlagen.
            </p>
            <p>
              Eine Kontolöschung beendet keine bereits bei einem externen Zahlungsanbieter bestehenden Vertrags- oder Zahlungspflichten. Falls ein kostenpflichtiges Abonnement besteht, kläre dessen Beendigung vor der Löschung über die jeweils vorgesehene Aboverwaltung oder den Support.
            </p>
          </Section>

          <Section title="Hilfe">
            <p>
              Wenn du dich nicht mehr anmelden kannst oder beim Löschvorgang technische Hilfe brauchst, wende dich an{" "}
              <a className="underline" href="mailto:info@femmesmarketing.com?subject=Hilfe%20zur%20Kontol%C3%B6schung%20Business%20Studio%20Suite">info@femmesmarketing.com</a>.
            </p>
          </Section>
        </article>

        <p className="mx-auto mt-6 max-w-4xl text-xs leading-5 text-slate-500">
          Stand: 29.09.2026 · Diese Informationen beschreiben den technischen Selbstlöschweg der Business Studio Suite.
        </p>
      </div>
    </main>
  );
};

export default AccountDeletionPage;
